// test: yarn jest src/models/__tests__/Customer.model.spec.js
export default class Customer {
  constructor(rawData) {
    this._rawData = rawData;
  }

  // 使用者已經進行 Line 登入，並且在註冊表單完成註冊
  get hasRegistered() {
    return false === [null, undefined].includes(this?._rawData?.registered_at)
  }
}
